import { Injectable } from '@angular/core';

import { EpcotConfig, Sitecore } from '@frontend/sports/common/client-config-data-access';
import { ConfirmationDialogButtonType, ConfirmationDialogService } from '@frontend/sports/modal/feature';

import { IBetslipState } from '../../../../base/store/state';
import { PickId } from '../../../../core/picks/pick-id';
import { PickType } from '../../../../core/picks/pick-models';

@Injectable()
export class EditBetV2PickAddConfirmationDialogService {
    constructor(
        private confirmationDialog: ConfirmationDialogService,
        private siteCore: Sitecore,
        private epcotConfig: EpcotConfig,
    ) {}

    shouldShow(pickId: PickId, betslipState: IBetslipState): boolean {
        // Should show it if no v2 picks added and current pick is V2.
        return (
            pickId.getPickType() !== PickType.V1Pick &&
            [...betslipState.types.editBet.picks.pickList, ...betslipState.types.editBet.addPicksState.pickList].every(
                (p) => p.id.getPickType() === PickType.V1Pick,
            )
        );
    }

    show(): Promise<ConfirmationDialogButtonType | undefined> {
        const ref = this.confirmationDialog.showDialog({
            title: this.siteCore.betslip.editBet.header,
            message: this.siteCore.betslip.editBet.confirmV2PickInEditBetNoCashOut,
            buttons: [
                {
                    buttonType: ConfirmationDialogButtonType.Cancel,
                    buttonTitle: this.siteCore.betslip.editBet.cancel,
                    buttonConfig: {
                        kind: this.epcotConfig.isEnabled ? 'secondary' : 'tertiary',
                        variant: 'outline',
                        size: 'large',
                    },
                },
                {
                    buttonType: ConfirmationDialogButtonType.Ok,
                    buttonTitle: this.siteCore.betslip.editBet.confirmButtonTitle,
                    buttonConfig: {
                        kind: 'primary',
                        variant: 'filled',
                        size: 'large',
                    },
                },
            ],
        });

        // Catch closing dialog using backdrop click
        return ref.result.catch(() => {});
    }
}
